import { Layout, Menu } from 'antd';
import styled from 'styled-components';

const { Sider, Content } = Layout;

export const StyledLayout = styled(Layout)`
  height: 100vh;
  width: 100vw;
`;
export const StyledInnerLayout = styled(Layout)`
  height: 100%;
  width: 100%;
  padding: 0 8px 8px;
`;

export const StyledSider = styled(Sider)`
  background: ${(props) => props.background};
`;

export const StyledMenu = styled(Menu)`
  height: 100%;
  border-right: 0;
`;

export const StyledContent = styled(Content)`
  padding: 8px;
  margin: 0;
  min-height: 280px;
  height: calc(
    100vh - 64px - 24px
  ); /* 64px pour le header, 24px pour le padding bottom */
  overflow: hidden;
  background: ${(props) => props.background};
  border-radius: ${(props) => props.$borderRadius};
  display: flex;
  flex-direction: column;
`;
